<template>
  <div>
    <div>
      <div class="pc_header_logo_box">
        <router-link v-show="tenantLogo.logoType==1" :to="{name:'home'}"><img :src="tenantLogo.logo" height="100"/></router-link>
        <router-link class="pc_header_logo_txt" v-show="tenantLogo.logoType==2" :to="{name:'home'}"><span class="pc_header_logo_txt1">{{tenantLogo.logo2}} </span> <span class="pc_header_logo_txt2"> {{tenantLogo.logo3}}</span></router-link>
      </div>
      <div class="pc_login_img_box">
        <div @click="goto(LoginBannerData)" class="pc_login_img"><img :src="LoginBannerData.registeredPic" alt=""></div>
        <div v-show="b==1" class="pc_login_box1">
          <div class="pc_login_box1_login_type clearfix_">
            <div @click="switchSignIn(1)" :class="(signInType==1?'pc_login_box1_login_type_active':'')" class="fl pc_login_box1_login_type1">密码登录</div>
            <div @click="switchSignIn(2)" :class="(signInType==2?'pc_login_box1_login_type_active':'')" class="fl pc_login_box1_login_type2">短信登录</div>
          </div>
          <div v-show="signInType==1" class="pc_login_box1_input_box">
            <div class="pc_login_box1_input_username"><input type="text" placeholder="用户名/手机号" v-model="userName"></div>
            <div class="pc_login_box1_input_password"><input type="password" placeholder="密码" v-model="userPassword"></div>
            <div class="pc_login_box1_input_code clearfix_">
              <div class="fl pc_login_box1_input_code_txt"><input type="text" placeholder="验证码" v-model="signInTxtCode"></div>
              <div class="fl pc_login_box1_input_code_img"><img :src="codeImg" alt=""></div>
              <div @click="getCodeImg" class="fl pc_login_box1_input_code_refresh">换一张</div>
            </div>
            <div @click="userLogin" class="pc_login_box1_input_btn">登&nbsp;录</div>
            <div class="pc_login_box1_input_link clearfix_">
              <div @click="goToSetpassword" class="fl">忘记密码</div>
              <div @click="registerNow" class="fr">立即注册</div>
            </div>
            <div class="pc_login_box1_agreement">若手机号未注册，将会进入注册流程。注册即视为同意<span @click="goToUserAgreement">《初牛用户协议》，</span><span @click="goToPrivacyAgreement">《隐私权政策》</span></div>
          </div>
          <div v-show="signInType==2" class="pc_login_box2_input_box">
            <div class="pc_login_box1_input_userphone"><input type="text" placeholder="手机号" v-model="userPhone"></div>
            <div class="pc_login_box2_input_box_code_box clearfix_">
              <div class="fl pc_login_box2_input_box_code_box_input"><input type="text" placeholder="验证码" v-model="phoneCode"></div>
              <div @click="getPhoneCode" class="fl pc_login_box2_input_box_code_box_btn">{{time?time:'获取手机验证码'}}</div>
            </div>
            <div @click="userLogin" class="pc_login_box1_input_btn">登&nbsp;录</div>
          </div>
        </div>
        <div v-show="b==2" class="pc_register_now">
          <div class="pc_register_now_title clearfix_">
            <div class="pc_register_now_title_txt fl">注册会员</div>
            <div @click="backLogin" class="pc_register_now_title_btn fr">返回登录</div>
          </div>
          <div class="pc_register_now_input_box">
            <div class="pc_register_now_input"><input type="text" placeholder="手机号" v-model="registerPhone" @blur="isMember"></div>
            <div class="pc_register_now_input"><input type="text" placeholder="登录名" v-model="registerName"></div>
            <div class="pc_register_now_input"><input type="text" placeholder="密码" v-model="registerPassword1"></div>
            <div class="pc_register_now_input"><input type="text" placeholder="确认密码" v-model="registerPassword2"></div>
            <div class="pc_register_now_code_box clearfix_">
              <div class="pc_register_now_code_txt pc_register_now_input fl"><input type="text" placeholder="验证码" v-model="registerCode"></div>
              <div @click="getPhoneCode" class="pc_register_now_code_btn fl">{{time?time:'获取手机验证码'}}</div>
            </div>
            <div @click="registerMember" class="pc_register_now_btn">注&nbsp;册</div>
            <div class="pc_register_now_agreement clearfix_">
              <input style="margin-top:2px;" class="fl" type="checkbox" @click="changeChecked" :checked="isChecked">
              <div class="fl">&nbsp;&nbsp;我已阅读并同意<span @click="goToUserAgreement">《初牛用户协议》，</span><span @click="goToPrivacyAgreement">《隐私权政策》</span></div>
            </div>
          </div>
        </div>
        <div v-show="b==3" class="pc_binding_member_box">
          <div class="pc_binding_member_title">绑定会员</div>
          <div class="pc_binding_member_input_box">
            <div class="pc_binding_member_input"><input type="text" placeholder="手机号" v-model="registerPhone" @blur="isMember"></div>
            <div class="pc_register_now_code_box clearfix_">
              <div class="pc_register_now_code_txt pc_register_now_input fl"><input type="text" placeholder="验证码" v-model="registerCode"></div>
              <div @click="getPhoneCode" class="pc_register_now_code_btn fl">{{time?time:'获取手机验证码'}}</div>
            </div>
            <div @click="bindingTenant" class="pc_register_now_btn">绑&nbsp;定</div>
          </div>
        </div>
        <div v-show="b==4" class="pc_setpassword_box">
          <div class="pc_binding_member_title">设置登录密码</div>
            <div class="pc_binding_member_input"><input type="text" placeholder="登录密码" v-model="registerPassword1"></div>
            <div class="pc_binding_member_input"><input type="text" placeholder="再次输入" v-model="registerPassword2"></div>
            <div @click="updaPassword" class="pc_register_now_btn">保&nbsp;存</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pc_header_logo_box{
  width: 1200px;
  margin: 0 auto;
  height: 100px;
}
.pc_header_logo{
  width: 458px;
  height: 100px;
  margin-top: 35px;
  text-align: center;
}
.pc_header_logo_txt1{
  font-size: 30px;
  color: #fb0;
  margin-right: 10px;
}
.pc_header_logo_txt2{
  font-size: 20px;
}
.pc_header_logo_txt{
  line-height: 60px;
}
.pc_login_img_box{
  width: 100%;
  height: 540px;
  position: relative;
}
.pc_login_img{
  width: 100%;
  height: 540px;
}
.pc_login_img{
  height: 540px;
  text-align: center;
}
.pc_login_box1{
  position: absolute;
  right: 300px;
  top: 80px;
  width: 272px;
  height: 300px;
  padding: 45px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 15px;
}
.pc_login_box1_login_type{
  height: 54px;
  font-size: 18px;
  margin-bottom: 20px;
  margin-top: -20px;
}
.pc_login_box1_login_type1,.pc_login_box1_login_type2{
  width: 50%;
  line-height: 54px;
  border-bottom: 1px solid #f2f2f2;
  text-align: center;
  cursor: pointer;
}
.pc_login_box1_login_type_active{
  color: #ef4f4f;
  border-bottom: 1px solid #ef4f4f;
}
.pc_login_box1_input_username input,.pc_login_box1_input_password input,.pc_login_box1_input_userphone input{
  border: 1px solid #bfbdbf;
  border-radius: 6px;
  height: 36px;
  color: #777;
  padding-left: 8px;
  width: 262px;
  margin-bottom: 20px;
  outline: none;
}
.pc_register_now_input input,.pc_binding_member_input input{
  border: 1px solid #bfbdbf;
  border-radius: 6px;
  height: 36px;
  color: #777;
  padding-left: 8px;
  width: 262px;
  margin-bottom: 15px;
  outline: none;
}
.pc_register_now_code_txt input{
  width: 120px;
  margin-bottom: 0;
}
.pc_login_box1_input_code{
  margin-bottom: 20px;
}
.pc_login_box1_input_code_txt input{
  width: 117px;
  border: 1px solid #bfbdbf;
  border-radius: 6px;
  height: 36px;
  color: #777;
  padding-left: 8px;
  outline: none;
}
.pc_login_box1_input_code_img{
  width: 80px;
  height: 30px;
  margin-top: 4px;
  margin-left: 15px;
}
.pc_login_box1_input_code_refresh{
  line-height: 38px;
  margin-left: 5px;
  font-size: 12px;
  cursor: pointer;
  color: #007130;
}
.pc_login_box1_input_btn{
  border: 1px solid #b8010f;
  text-align: center;
  height: 36px;
  line-height: 36px;
  width: 270px;
  border-radius: 6px;
  background: #dd2d3a;
  font-family: \\5FAE\8F6F\96C5\9ED1;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 15px;
}
.pc_login_box1_input_link{
  color: #616060;
  font-size: 13px;
  margin-bottom: 10px;
}
.pc_login_box1_input_link div{
  cursor: pointer;
}
.pc_login_box1_agreement{
  color: #616060;
  width: 280px;
  line-height: 16px;
}
.pc_login_box1_agreement span{
  color: rgb(255, 102, 0);
  cursor: pointer;
}
.pc_login_box2_input_box_code_box{
  margin-bottom: 45px;
}
.pc_login_box2_input_box_code_box_input input{
  width: 120px;
  border: 1px solid #bfbdbf;
  border-radius: 6px;
  height: 36px;
  color: #777;
  padding-left: 8px;
}
.pc_login_box2_input_box_code_box_btn{
  width: 120px;
  height: 38px;
  background: #dd2d3a;
  color: #fff;
  margin-left: 18px;
  text-align: center;
  font-size: 14px;
  line-height: 38px;
  border-radius: 6px;
  cursor: pointer
}
.pc_register_now{
  padding: 21px;
  padding-bottom: 30px;
  width: 298px;
  padding-left: 42px;
  height: 360px;
  background: #fff;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 15px;
  position: absolute;
  right: 300px;
  top: 80px;
}
.pc_register_now_title{
  margin-bottom: 20px;
}
.pc_register_now_title_txt{
  color: #616060;
  font-weight: 400;
  font-size: 20px;
  display: block;
  width: 120px;
}
.pc_register_now_title_btn{
  cursor: pointer;
}
.pc_register_now_code_box{
  margin-bottom: 15px;
}
.pc_register_now_code_btn{
  width: 120px;
  padding: 0;
  margin-left: 18px;
  background: #dd2d3a;
  color: #fff;
  height: 36px;
  border-radius: 6px;
  line-height: 36px;
  text-align: center;
  font-size: 13px;
  cursor: pointer;
}
.pc_register_now_btn{
  border: 1px solid #b8010f;
  height: 36px;
  line-height: 36px;
  width: 270px;
  border-radius: 6px;
  background: #dd2d3a;
  font-family: \\5FAE\8F6F\96C5\9ED1;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  margin-bottom: 15px;
}
.pc_register_now_agreement{
  height: 16px;
  line-height: 16px;
  width: 100%;
}
.pc_register_now_agreement span{
  cursor: pointer;
  color: #f60;
}
.pc_binding_member_box,.pc_setpassword_box{
  padding: 21px;
  padding-bottom: 30px;
  width: 298px;
  padding-left: 42px;
  height: 190px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 15px;
  position: absolute;
  top: 130px;
  right: 300px;
}
.pc_binding_member_title{
  color: #616060;
  font-weight: 400;
  font-size: 20px;
  display: block;
  margin-bottom: 20px;
  width: 120px;
}
.pc_setpassword_box{
  
}
</style>

<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,sha1 } from '../../assets/js/public.js'
import Cookies from 'js-cookie'
export default {
  data(){
    return {
      LoginBannerData:{},
      tenantLogo:{},
      signInType:1,
      userName:'',
      userPassword:'',
      signInTxtCode:'',
      codeImg:'',
      userPhone:'',
      phoneCode:'',
      time:0,
      oldUrl:'',
      oldData:{},
      b:1,
      isChecked:true,
      registerPhone:'',
      registerName:'',
      registerPassword1:'',
      registerPassword2:'',
      registerCode:'',
      member0bj:{}
    }
  },
  computed:{
    
  },
  created:function(){
    var t_=this
    $(document).keyup(function(event){
      if(event.keyCode==13&&t_.$route.path=='/loginHome'){
        t_.userLogin()
      }
    })
  },
  mounted:function(){
    this.oldUrl=this.$route.query.oldRoter
    this.oldData=this.$route.query.oldData
    this.tenantLogo=JSON.parse(localStorage.getItem('tenantLogo'))
    this.getLoginPic()
    this.getCodeImg()
  },
  methods:{
    updaPassword:function(){
      var t_ = this
      if(!t_.registerPassword1||!t_.registerPassword2)return t_.$message({
        message:'请输入密码',
        center:true,
        type:'warning'
      })
      if(t_.registerPassword1!=t_.registerPassword2)return t_.$message({
        message:'密码输入不一致',
        center:true,
        type:'warning'
      })
      var data0bj = Qs.stringify({
        phone:t_.restelphone,
        password:sha1(t_.registerPassword1)
      })
      axios.post(`${ip}formWorkInterface/setLoginPassage`,data0bj).then( res => {
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.b=1
          this.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }else{
          this.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      } )
    },
    bindingTenant:function(){
      var t_=this
      if(!t_.registerPhone)return t_.$message({
        message:'请输入手机号',
        center:true,
        type:'warning'
      })
      if(!t_.registerCode)return t_.$message({
        message:'请输入验证码',
        center:true,
        type:'warning'
      })
      var data0bj = Qs.stringify({
        mobile:t_.registerPhone,
        verifyCode:t_.registerCode,
        memberId:t_.member0bj.member_id,
        channel:2
      })
      axios.post(`${ip}formWorkInterface/bindingTenant`,data0bj).then( res => {
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          if(!res.data.password)return t_.b=4
          t_.b=1
          t_.userName=t_.registerPhone
        }
        if(res.data.code==2)return t_.$message({
          message:res.data.message,
          center:true,
          type:'warning'
        })
      } )
    },
    isMember:function(){
      var t_ = this
      if(!t_.registerPhone)return
      var data0bj = Qs.stringify({
        mobilePhone:t_.registerPhone,
        channel:2
      })
      axios.post(`${ip}formWorkInterface/phoneMember`,data0bj).then( res => {
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.status==1){
        }else if(res.data.status==2){
          t_.b=1
          t_.userName=t_.registerPhone
        }else if(res.data.status==3){
          t_.b=3
          t_.member0bj=res.data.member
        }
      } )
    },
    registerMember:function(){
      var t_=this
      if(!t_.registerPhone)return t_.$message({
        message:'请输入手机号',
        center:true,
        type:'warning'
      })
      if(!t_.registerName)return t_.$message({
        message:'请输入登录名',
        center:true,
        type:'warning'
      })
      if(!t_.registerPassword1||!t_.registerPassword2)return t_.$message({
        message:'请输入密码',
        center:true,
        type:'warning'
      })
      if(t_.registerPassword1!=t_.registerPassword2)return t_.$message({
        message:'密码输入不一致',
        center:true,
        type:'warning'
      })
      if(!t_.registerCode)return t_.$message({
        message:'请输入验证码',
        center:true,
        type:'warning'
      })
      if(!t_.isChecked)return t_.$message({
        message:'请认真阅读《初牛用户协议》，《隐私权政策》并勾选。',
        center:true,
        type:'warning'
      })
      var data0bj = Qs.stringify({
        mobile:t_.registerPhone,
        verifyCode:t_.registerCode
      })
      axios.post(
        `${ip}formWorkInterface/validationCode`,data0bj
      ).then( res => {
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.message!='success')return t_.$message({
          message:'验证码错误',
          center:true,
          type:'warning'
        })
        t_.registeredBtn()
      } )
    },
    registeredBtn:function () {
      var t_=this
      const url = `${ip}formWorkInterface/saveMember`;
      let data = Qs.stringify({"mobilePhone":t_.registerPhone,"nickname":t_.registerName,"password":sha1(t_.registerPassword1),"channel":2});
      axios.post(url,data).then(res => {
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.status==6){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
          t_.b=1
          t_.userName=t_.registerPhone
          return 
        }
        if(res.data.status==4)return t_.$message({
          message:res.data.message,
          center:true,
          type:'warning'
        })
        if(res.data.status==0){
          localStorage.setItem('name',res.data.user.name);
          localStorage.setItem('tamp',res.data.memberLoginToken)
          Cookies.set('name', res.data.member.name)
          Cookies.set('tamp', res.data.memberLoginToken)
          if(t_.$route.name == "loginHome"){
            t_.$router.push(t_.$route.query.redirect || '/')
          }
        }
      })
    },
    changeChecked:function(){
      this.isChecked=!this.isChecked
    },
    backLogin:function(){
      this.b=1
    },
    registerNow:function(){
      this.b=2
    },
    goToSetpassword:function(){
      var href=this.$router.resolve({name:'SetPWD1',query:{step:1}})
      window.open(href.href,'_blank')
    },
    goToUserAgreement:function(){
      var href=this.$router.resolve({name:'userAgreement'});
      window.open(href.href,'_blank')
    },
    goToPrivacyAgreement:function(){
      var href=this.$router.resolve({name:'privacyAgreement'});
      window.open(href.href,'_blank')
    },
    userLogin:function () {
      var t_=this
      if(t_.signInType==1){
        if(!t_.userName)return t_.$message({
          message:'请输入用户名/手机号',
          center:true,
          type:'warning'
        })
        if(!t_.userPassword)return t_.$message({
          message:'请输入密码',
          center:true,
          type:'warning'
        })
        if(!t_.signInTxtCode)return t_.$message({
          message:'请输入验证码',
          center:true,
          type:'warning'
        })
      }else if(t_.signInType==2){
        if(!t_.phoneCode)return t_.$message({
          message:'请输入验证码',
          center:true,
          type:'warning'
        })
      }
      var data = {
        channel:2
      }
      if(t_.signInType==1){
        data.mobilephone=t_.userName
        data.authCode=t_.signInTxtCode
        data.password=sha1(t_.userPassword)
      }else{
        data.mobilephone=t_.userPhone
        data.verifyCode=t_.phoneCode
        data.loginType=1
      }
      var xhrFields = {
        withCredentials: true
      }
      axios.post(`${ip}formWorkInterface/checkMemberPc`,Qs.stringify(data),xhrFields).then(res => {
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          localStorage.setItem('name',res.data.member.name);
          localStorage.setItem('tamp',res.data.memberLoginToken)
          Cookies.set('name', res.data.member.name)
          Cookies.set('tamp', res.data.memberLoginToken)
          // if(t_.oldUrl=='/goodsdetails')return t_.$router.push({path:'/'})
          t_.$router.push({path:t_.oldUrl,query:t_.oldData})
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
          if(t_.signInType==1){
            t_.signInTxtCode=''
            t_.getCodeImg()
          }
        }
      })
    },
    getPhoneCode:function(){
      var t_=this
      if(t_.time>0)return t_.$message({
        message:'60秒只能获取一条验证码哦~！',
        center:true,
        type:'warning'
      })
      var data0bj = {}
      if(t_.b==1){
        if(t_.userPhone==''){
          return t_.$message({
            message:'请输入手机号',
            center:true,
            type:'warning'
          })
        }else{
          var re2 = /\d{11}$/
          if (!re2.test(t_.userPhone)) {
            return this.$message({
              message:'手机号码输入有误',
              center:true,
              type:'warning'
            })
          }
        }
        data0bj.mobilePhone=t_.userPhone
      }else{
        if(t_.registerPhone==''){
          return t_.$message({
            message:'请输入手机号',
            center:true,
            type:'warning'
          })
        }else{
          var re2 = /\d{11}$/
          if (!re2.test(t_.registerPhone)) {
            return this.$message({
              message:'手机号码输入有误',
              center:true,
              type:'warning'
            })
          }
        }
        data0bj.mobilePhone=t_.registerPhone
      }
      axios.post(`${ip}formWorkInterface/WxCode`,Qs.stringify(data0bj)).then( res => {
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==1){
          t_.time=60
          t_.countDown()
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      } )
    },
    countDown:function(){
      var t_=this
      var fn=function(){
        setTimeout(function(){
          t_.time=--t_.time
          if(t_.time>0){
            fn()
          }
        },1000,t_)
      }
      fn()
    },
    getCodeImg:function(){
      var t_=this
      var timestamp=Date.parse(new Date())
      var data0bj=Qs.stringify({
        t:timestamp
      })
      var xhrFields = {
        withCredentials: true
      }
      axios.post(
        `${ip}formWorkInterface/verifyCode`,data0bj,xhrFields
      ).then( res => {
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0)t_.codeImg='data:image/png;base64,'+res.data.pic
      } )
    },
    switchSignIn:function(n){
      var t_=this
      t_.b=1
      t_.signInType=n
      if(n==1){
        t_.userPhone=''
        t_.phoneCode=''
      }else{
        t_.userName=''
        t_.userPassword=''
        t_.signInTxtCode=''
      }
    },
    go404:function(msg){
      var href=this.$router.resolve({name:'err404',query:{txt:msg}})
      window.open(href.href,'_blank')
    },
    getLoginPic:function(){
      var t_=this
      var data0bj = Qs.stringify({
        channel:2
      })
      axios.post(`${ip}formWorkInterface/getLoginPic`,data0bj).then(res=>{
        if(res.data.code==300)return t_.go404(res.data.message)
        if(res.data.code==0){
          t_.LoginBannerData=res.data.data
        }
      })
    },
    goto:function(obj){
      var t_ = this
      if( obj.registeredStatus==1 ){
        if(obj.atriceId=='')return
        var href=this.$router.resolve({name:'articleList',query:{id:obj.atriceId}})
        window.open(href.href,'_blank')
      }else if(obj.registeredStatus==2){
        var href=this.$router.resolve({name:'goodslist',query:{id:obj.categoryId}})
        window.open(href.href,'_blank')
      }else if(obj.registeredStatus==3){
        var href=this.$router.resolve({name:'goodslist',query:{txt: search}})
        window.open(href.href,'_blank')
      }else if(obj.registeredStatus==5){
        window.open(obj.link)
      }else if(obj.registeredStatus==6){
        var href=t_.$router.resolve({name:'goodsdetails',query:{goodsId:obj.goodsId,isSupplyChainGoods:2,supplyChainTenantId:obj.supplyChainTenantId}})
        window.open(href.href,'_blank')
      }else if(obj.status==4){
        var href=t_.$router.resolve({name:obj.formwordPcLocal,query:{id:obj.formwordId}})
        window.open(href.href,'_blank')
      }else if(obj.status==9){
        if(obj.module==1){
          var href=this.$router.resolve({name:'teamGoods'});
          window.open(href.href,'_blank')
        }else if(obj.module==3){
          var href=this.$router.resolve({name:'couponList'});
          window.open(href.href,'_blank')
        }else if(obj.module==5){
          var href=this.$router.resolve({name:'activityList'});
          window.open(href.href,'_blank')
        }else if(obj.module==6){
          var href=this.$router.resolve({name:'scoreChange'});
          window.open(href.href,'_blank')
        }
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login/index.vue